var map = {
	"./Page01.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page01.jpg",
	"./Page01_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page01_org.jpg",
	"./Page02.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page02.jpg",
	"./Page02_jerry.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page02_jerry.jpg",
	"./Page02_jerry_new.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page02_jerry_new.jpg",
	"./Page02_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/Page02_org.jpg",
	"./bg_cover.png": "./src/EGRContent/Story/LadduRaPeda/images/bg_cover.png",
	"./bg_cover01.png": "./src/EGRContent/Story/LadduRaPeda/images/bg_cover01.png",
	"./bg_cover02.png": "./src/EGRContent/Story/LadduRaPeda/images/bg_cover02.png",
	"./coverpage.jpg": "./src/EGRContent/Story/LadduRaPeda/images/coverpage.jpg",
	"./jerry.png": "./src/EGRContent/Story/LadduRaPeda/images/jerry.png",
	"./jerry1.png": "./src/EGRContent/Story/LadduRaPeda/images/jerry1.png",
	"./jerry2.png": "./src/EGRContent/Story/LadduRaPeda/images/jerry2.png",
	"./jumping_laddu.gif": "./src/EGRContent/Story/LadduRaPeda/images/jumping_laddu.gif",
	"./jumping_laddu.png": "./src/EGRContent/Story/LadduRaPeda/images/jumping_laddu.png",
	"./jumping_laddu1.gif": "./src/EGRContent/Story/LadduRaPeda/images/jumping_laddu1.gif",
	"./jumping_peda.gif": "./src/EGRContent/Story/LadduRaPeda/images/jumping_peda.gif",
	"./jumping_peda.png": "./src/EGRContent/Story/LadduRaPeda/images/jumping_peda.png",
	"./jumping_peda1.gif": "./src/EGRContent/Story/LadduRaPeda/images/jumping_peda1.gif",
	"./laddu_back_view.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_back_view.gif",
	"./laddu_blink.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_blink.gif",
	"./laddu_cover_page.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_cover_page.gif",
	"./laddu_cover_page.png": "./src/EGRContent/Story/LadduRaPeda/images/laddu_cover_page.png",
	"./laddu_front_of_sun.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_front_of_sun.gif",
	"./laddu_page01.png": "./src/EGRContent/Story/LadduRaPeda/images/laddu_page01.png",
	"./laddu_page02.png": "./src/EGRContent/Story/LadduRaPeda/images/laddu_page02.png",
	"./laddu_page04.png": "./src/EGRContent/Story/LadduRaPeda/images/laddu_page04.png",
	"./laddu_page05.png": "./src/EGRContent/Story/LadduRaPeda/images/laddu_page05.png",
	"./laddu_peda_hugging.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_peda_hugging.gif",
	"./laddu_under_tree.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_under_tree.gif",
	"./laddu_walk.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_walk.gif",
	"./laddu_walk_back.gif": "./src/EGRContent/Story/LadduRaPeda/images/laddu_walk_back.gif",
	"./page03.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page03.jpg",
	"./page03_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page03_org.jpg",
	"./page03_tree.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page03_tree.jpg",
	"./page04.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page04.jpg",
	"./page04_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page04_org.jpg",
	"./page05.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page05.jpg",
	"./page05_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page05_org.jpg",
	"./page06.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page06.jpg",
	"./page06_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page06_org.jpg",
	"./page07.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page07.jpg",
	"./page07_org.jpg": "./src/EGRContent/Story/LadduRaPeda/images/page07_org.jpg",
	"./peda_back_view.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_back_view.gif",
	"./peda_blink.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_blink.gif",
	"./peda_cover_page.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_cover_page.gif",
	"./peda_page02.png": "./src/EGRContent/Story/LadduRaPeda/images/peda_page02.png",
	"./peda_page03.png": "./src/EGRContent/Story/LadduRaPeda/images/peda_page03.png",
	"./peda_page05.png": "./src/EGRContent/Story/LadduRaPeda/images/peda_page05.png",
	"./peda_page_cover_page.png": "./src/EGRContent/Story/LadduRaPeda/images/peda_page_cover_page.png",
	"./peda_under_tree.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_under_tree.gif",
	"./peda_walk.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_walk.gif",
	"./peda_walk_back.gif": "./src/EGRContent/Story/LadduRaPeda/images/peda_walk_back.gif",
	"./thumnail.png": "./src/EGRContent/Story/LadduRaPeda/images/thumnail.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/LadduRaPeda/images sync recursive ^\\.\\/.*$";